export enum Status {
  DEFAULT,
  FUTUREDISABLED,
  PREVIOUSDISABLED,
};
